import { inject, injectable } from 'inversify-props';
import { IHttpClient } from './HttpClient';
import { ILogger } from './LoggerService';
import { ISettings } from './SettingsService';
import { PagedResult, Gender } from '../../models';
import { IBaseService } from '../BaseService';


export interface IGenderService extends IBaseService<Gender, number> {
	getMultiple(ids: number[]): Promise<Gender[]>;
	autocomplete(crtieria: string): Promise<Gender[]>;
}


@injectable()
export class GenderService implements IGenderService {

	private cache: Promise<Gender[]>;

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(id: number): Promise<Gender> {
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}/${id}`;
		return this.httpClient.get<Gender>(url);
	}

	public getMultiple(ids: number[]): Promise<Gender[]> {
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}/multiple/${ids.join(',')}`;
		return this.httpClient.get<Gender[]>(url);
	}

	public autocomplete(criteria: string): Promise<Gender[]> {
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}/autocomplete/${criteria}`;
		return this.httpClient.get<Gender[]>(url);
	}

	public page(pageIndex: number, pageSize: number): Promise<PagedResult<Gender>> {
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<Gender>>(url);
	}

	public list(): Promise<Gender[]> {
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}`;
		if (!this.cache) { this.cache = this.httpClient.get<Gender[]>(url); }
		return this.cache;
	}

	public save(model: Gender): Promise<Gender> {
		this.cache = null; // INVALIDATE CACHE
		const payload = {
			name: model.name,
			id: model.id,
			sortBy: model.sortBy != null ? parseInt(model.sortBy.toString(), null) : 0,
		};
		let url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}`;
		if (model.id !== null && model.id !== undefined) {
			url += `/${model.id}`;
			return this.httpClient.put(url, payload);
		}
		return this.httpClient.post(url, payload);
	}

	public delete(id: number): Promise<any> {
		this.cache = null; // INVALIDATE CACHE
		const url = `${this.settings.baseUrl}${this.settings.genderBaseUrl}/${id}`;
		return this.httpClient.delete(url);
	}

}
